import { Capacitor } from '@capacitor/core'
import { supabaseRpc, getCurrentUserId } from '@/lib/supabase'
import { getAppVersion } from '@/utils/appVersion'
import type { PaywallDismissReason } from '@/composables/usePaywallDismissReason'

export interface PaywallDismissReasonRecord {
  surface: string
  paywallKind: 'native' | 'web'
  reason: PaywallDismissReason | null
  householdId: string | null
}

/**
 * Enregistre en base la réponse à « pourquoi pas Harmonia+ ? », en plus de
 * l'évènement Amplitude. Amplitude ne voit rien de la PWA et ne se croise pas
 * avec le foyer ; cette table, si (voir la migration 20260918120000).
 *
 * N'échoue jamais : la fermeture du paywall ne doit pas dépendre du réseau. Une
 * réponse perdue coûte une ligne de mesure, une exception coûterait l'écran.
 */
export async function recordPaywallDismissReason(record: PaywallDismissReasonRecord): Promise<boolean> {
  try {
    // getCurrentUserId lit la session en cache ; getUser() ferait un aller-retour
    // réseau à chaque fermeture (règle du dépôt).
    const userId = await getCurrentUserId()
    if (!userId) return false
    const { error } = await supabaseRpc.from('paywall_dismiss_reasons').insert({
      user_id: userId,
      household_id: record.householdId,
      surface: record.surface || 'unknown',
      paywall_kind: record.paywallKind,
      reason: record.reason,
      platform: Capacitor.getPlatform(),
      app_version: await getAppVersion(),
    })
    if (error) {
      console.warn('[paywallDismissReason] réponse non enregistrée:', error.message)
      return false
    }
    return true
  } catch (err) {
    console.warn('[paywallDismissReason] réponse non enregistrée:', err)
    return false
  }
}
